import { render, staticRenderFns } from "./ReShowClientMobile.vue?vue&type=template&id=190a2bea&scoped=true"
import script from "./ReShowClientMobile.vue?vue&type=script&lang=js"
export * from "./ReShowClientMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190a2bea",
  null
  
)

export default component.exports